(function() { window.GUID_289bf940_b8a8_4da2_8b83_c1e090277dd0 = { getGuid: function() { return "289bf940-b8a8-4da2-8b83-c1e090277dd0"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class ViewBase {
            get $Container() {
                if (this.$container) {
                    return this.$container;
                }
                return CS.DOM.$sectionMaster;
            }
            get isDebug() {
                var _a, _b;
                return (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.IsDebug()) !== null && _b !== void 0 ? _b : false;
            }
            constructor(contextKey = null) {
                this.tourData = null;
                let me = this;
                if (contextKey) {
                    this.SetDisposableContainer(contextKey);
                }
                CS.Views.ViewBase.CurrentView = this;
                //Marche pas parce que sur un overlay close, ca flush le contenu de la masterpage
                //CS.DOM.$body.offon('sectionmasterreplacing.page masterpageoverlayclose.page', function () {
                CS.DOM.$body.offon("sectionmasterreplacing.page", function () {
                    me.Dispose();
                });
                CS.DOM.$body.offon("click.addfavorite", ".cs-favorite-button:not(.cs-popup-auto-trigger)", this.ToggleFavorite);
                this.loadTourData();
                this.OnDiscoveringDOM();
                this.OnBindEvents();
                CS.Ads.RefreshGoogleAds(this.$Container);
                this.TestVersion();
            }
            loadTourData() {
                try {
                    const $tourData = CS.DOM.$body.find("#cs-app-tour-data");
                    if ($tourData.length && $tourData.is("input")) {
                        const _tourData = $tourData.val();
                        if (!CS.Helper.isNullOrWhiteSpace(_tourData)) {
                            const tourData = JSON.parse(_tourData);
                            if (tourData) {
                                const { Category, Key } = tourData;
                                if (Category && Key) {
                                    this.tourData = tourData;
                                }
                            }
                        }
                    }
                }
                catch (error) {
                    console.error("Error while loading tour data", error);
                }
            }
            SetDisposableContainer(contextKey) {
                let $container = $("#" + contextKey);
                CS.DOM.AssignInstanceToJQueryElement(this, $container);
                $container.addClass("disposable");
                this.$container = $container;
            }
            Dispose() {
                CS.DOM.DisposeChilds(this.$Container);
                CS.DOM.$body.off("sectionmasterreplacing.page");
                CS.Shared.WallSectionLazyLoader.dispose();
                this.tourData = null;
                this.OnDispose();
            }
            OnDiscoveringDOM() { }
            OnBindEvents() { }
            ///Cette fonction est appelé lorsque les styles dune vue sont appendé et que onload de chaque style fut appelé
            //Exemple, j'ai 3 styles appendé apres un call ajax, un compte de 3 sera demandé et lorsque ce nombre aura été atteint,
            //cette fonction sera appelé
            OnAllCssFilesLoaded() { }
            TestVersion() {
                if (CS.DOM.$body.data("version") != CS.DOM.$sectionMaster.data("version")) {
                    window.location.reload(true);
                }
            }
            Log(data, color = "white") {
                if (CS.CommonData.Current && CS.CommonData.Current.IsDebug()) {
                    console.log(`%c ${data}`, `color: ${color}`);
                }
            }
            ToggleFavorite(e) {
                e.preventDefault();
                e.stopPropagation();
                const url = CS.Url.CSUrl("UpdateUserFavorites");
                const $favoriteButton = $(e.currentTarget);
                const isFavorite = $favoriteButton.hasClass("is-favorite");
                const data = {
                    isFavorite: !isFavorite, // C'est normal, c'est le paramètre qui est mal nommé...
                    searchtype: $favoriteButton.data("type"),
                    searchedEntityId: $favoriteButton.data("id"),
                };
                const snackbarMessages = $favoriteButton.data("snackbar-messages");
                CS.Analytics.Event("Favorite", data.searchtype, "Global");
                CS.Ajax.Post(url, data, (response) => {
                    if (response.Success) {
                        $favoriteButton.toggleClass("is-favorite");
                        if (snackbarMessages != null) {
                            if (isFavorite) {
                                CS.Controls.Snackbar.Show({
                                    Id: "cs-favorite-button",
                                    Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                    Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                    Type: CS.Enumeration.SnackbarType.Info,
                                    AutoHideDuration: 3000,
                                    Message: snackbarMessages.removeFavoriteSnackbarMessage,
                                });
                            }
                            else {
                                CS.Controls.Snackbar.Show({
                                    Id: "cs-favorite-button",
                                    Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                    Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                    Type: CS.Enumeration.SnackbarType.Success,
                                    AutoHideDuration: 3000,
                                    Message: snackbarMessages.addFavoriteSnackbarMessage,
                                });
                            }
                        }
                    }
                });
            }
            static toggleFavorite($favoriteButton, callback) {
                const url = CS.Url.CSUrl("UpdateUserFavorites");
                const isFavorite = $favoriteButton.hasClass("is-favorite");
                const data = {
                    isFavorite: !isFavorite, // C'est normal, c'est le paramètre qui est mal nommé...
                    searchtype: $favoriteButton.data("type"),
                    searchedEntityId: $favoriteButton.data("id"),
                };
                const snackbarMessages = $favoriteButton.data("snackbar-messages");
                CS.Analytics.Event("Favorite", data.searchtype, "Global");
                CS.Ajax.Post(url, data, (response) => {
                    if (response.Success) {
                        $favoriteButton.toggleClass("is-favorite");
                        if (snackbarMessages != null) {
                            if (isFavorite) {
                                CS.Controls.Snackbar.Show({
                                    Id: "cs-favorite-button",
                                    Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                    Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                    Type: CS.Enumeration.SnackbarType.Info,
                                    AutoHideDuration: 3000,
                                    Message: snackbarMessages.removeFavoriteSnackbarMessage,
                                });
                            }
                            else {
                                CS.Controls.Snackbar.Show({
                                    Id: "cs-favorite-button",
                                    Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                    Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                    Type: CS.Enumeration.SnackbarType.Success,
                                    AutoHideDuration: 3000,
                                    Message: snackbarMessages.addFavoriteSnackbarMessage,
                                });
                            }
                        }
                        if (callback) {
                            callback(!isFavorite);
                        }
                    }
                });
            }
            //public ShowNotificationsPopup(e: JQueryEventObject) {
            //  e.preventDefault();
            //  e.stopPropagation();
            //  console.log("ShowNotificationsPopup");
            //  const url = Url.CSUrl("FriendShowNotificationsModal");
            //  const $notificationsButton = $(e.currentTarget);
            //  const isFollowing = $notificationsButton.hasClass("is-following");
            //  CS.Analytics.Event(
            //    "NotificationsPopup",
            //    $notificationsButton.data("id"),
            //    "Global"
            //  );
            //  const isLocked = $notificationsButton.hasClass("is-locked");
            //  if (isLocked) {
            //    const snackbarMessages = $notificationsButton.data("snackbar-messages");
            //    const lockedSnackbarMessage = snackbarMessages.lockedSnackbarMessage;
            //    if (lockedSnackbarMessage != null) {
            //      return Controls.Snackbar.Show({
            //        Id: "cs-notifications-button",
            //        Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
            //        Animation: CS.Enumeration.SnackbarAnimation.Slide,
            //        Type: CS.Enumeration.SnackbarType.Info,
            //        AutoHideDuration: 3000,
            //        Message: lockedSnackbarMessage,
            //      });
            //    }
            //  }
            //  const data = {
            //    //isFollowing: !isFollowing, // C'est normal, c'est le paramètre qui est mal nommé...
            //    //personaType: $notificationsButton.data("type"),
            //    friendPersonaId: $notificationsButton.data("id"),
            //    highlightedNotification: $notificationsButton.data("highlighted"),
            //  };
            //  let friendsControl = new CS.Shared.FriendControls();
            //  //const getFriendToolbarUrl = CS.Url.CSUrl("FriendGetFriendToolbar");
            //  const followUnfollowCallback = (isFollowing: boolean) => {
            //    if (isFollowing) {
            //      $notificationsButton.addClass("is-following");
            //    } else {
            //      $notificationsButton.removeClass("is-following");
            //    }
            //  };
            //  Controls.Popup.ShowAjaxModal(
            //    url,
            //    data,
            //    ({popup}) => {
            //      friendsControl.BindEvents(followUnfollowCallback);
            //      const $element = $('<div class="fetch-trigger"></div>');
            //      popup.$Control.append($element);
            //      popup.$Control.offon("click.fetchTrigger", ".fetch-trigger", (f) => {
            //        const isFollowing = $(f.target).data("is-following");
            //        if (isFollowing) {
            //          followUnfollowCallback(true);
            //        }
            //        popup.Refresh();
            //      });
            //    },
            //    ({popup}) => {
            //      friendsControl.Dispose(followUnfollowCallback);
            //      friendsControl = null;
            //    },
            //    true
            //  );
            //}
            ShowLoader({ id, $container, autoRemoveDelay, overContent, position, }) {
                const _$container = $container();
                if (_$container.length) {
                    if (overContent) {
                        _$container.addClass("cs-loader-container");
                    }
                    if (position == "prepend") {
                        _$container.prepend(`<div id="${id}" class="cs-loader"><div class="cs-loader-inner-content"></div></div>`);
                    }
                    else {
                        _$container.append(`<div id="${id}" class="cs-loader"><div class="cs-loader-inner-content"></div></div>`);
                    }
                    if (autoRemoveDelay != null) {
                        CS.Lag(id, autoRemoveDelay, () => {
                            $container().find(`#${id}`).remove();
                        });
                    }
                }
            }
            RemoveLoader({ id, $container, }) {
                var _a;
                $(`#${id}.cs-loader`).remove();
                if ((_a = $container === null || $container === void 0 ? void 0 : $container.length) !== null && _a !== void 0 ? _a : 0) {
                    $container.removeClass("cs-loader-container");
                }
            }
        }
        Views.ViewBase = ViewBase;
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ViewBase.js.map
